export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "r-v3/js/GrmMediaStreamTrackCanvasWorker.runner.44147b15.worker.js");
}
